var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProhibition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 30,
    height: 25,
    strokeWidth: 1.5,
    viewBox: "1000 1000 10000 8000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .fil0 {fill:#FFFFFF}\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M7303 5318c0,823 -291,1527 -874,2109 -582,584 -1286,875 -2109,875 -823,0 -1527,-291 -2109,-875 -583,-582 -874,-1286 -874,-2109 0,-823 291,-1527 874,-2109 582,-583 1286,-874 2109,-874 823,0 1527,291 2109,874 583,582 874,1286 874,2109zm-476 0c0,-692 -245,-1283 -735,-1772 -489,-490 -1079,-735 -1772,-735 -619,0 -1164,202 -1632,602l3533 3534c404,-469 606,-1012 606,-1629zm-959 1968l-3519 -3520c-357,454 -536,972 -536,1552 0,693 245,1284 735,1772 489,490 1079,735 1772,735 578,0 1094,-180 1548,-539z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProhibition);
export default __webpack_public_path__ + "static/media/Prohibition.de04d8f93137f429d99ac158a64f0101.svg";
export { ForwardRef as ReactComponent };